import type { Router } from "vue-router";
import type { NavItem } from "@/integration/nav";

/** What a click on a navbar entry does: its action, or its route. */
export function activateNavItem(item: NavItem, router: Router): void {
  if (item.disabled) return;
  if (item.action) {
    item.action();
    return;
  }
  if (!item.to) return;
  // Path strings stay absolute (`/erp/...`). Named locations use the
  // shell-prefixed name (e.g. erp.ConfigNumberSeries). Catch rejections
  // so a missing route doesn't look like a dead click.
  void Promise.resolve(router.push(item.to as never)).catch((err: unknown) => {
    console.warn("[ShellNavItem] navigation failed", item.id, item.to, err);
    if (typeof item.to === "string") {
      window.location.hash = item.to.startsWith("#") ? item.to : `#${item.to}`;
    }
  });
}
